<template>
    <h2 v-if="!!title && title.length > 0">{{ title }}</h2>
    <div class="">
        <div class="mb-3" v-show="!showExtraFields" ref="autocompleteWrapper">
            <!--            <label class="form-label">{{ (!!addressLabel && addressLabel.length > 0) ? addressLabel : 'Your Address'}}</label>-->
            <label v-if="!!addressLabel && addressLabel.length > 0" class="form-label">{{ addressLabel}}</label>
            <div class="autocomplete-wrapper" style="position: relative;">
                <input
                    class="form-control"
                    type="text"
                    @input.prevent="this.handleDebouncedInput"
                    :value="this.fullAddress"
                    :placeholder="this.getTranslatedText('__type_to_search__', 'fields.placeholders')"
                    :autocomplete="this.autocompleteInput"
                />
                <div v-if="this.showLoadingAnimation && this.fullAddress.length" class="searching-spinner"></div>
                <ul v-if="this.predictions.length" class="form-control dropdown-list" style="position: absolute; z-index: 10; background: white; width: 100%; border: 1px solid #ccc; ">
                    <li
                        v-for="prediction in this.predictions"
                        :key="prediction.place_id"
                        @click="this.selectPrediction(prediction)"
                        style="padding: 8px; cursor: pointer;"
                    >
                        {{ prediction.description }}
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="showExtraFields" class="">

            <div v-if="this.isStepReadOnly">
                <!--                <span>&#x2022; {{ (!!addressLabel && addressLabel.length > 0) ? addressLabel : 'Your Address'}}</span>-->
                <span v-if="!!addressLabel && addressLabel.length > 0">&#x2022; {{ addressLabel }}</span>
                <p class="text-muted" v-html="this.getReadOnlyFullAddress"></p>
            </div>

            <div v-else>
                <!--                <label class="form-label text-muted mb-3">{{ (!!addressLabel && addressLabel.length > 0) ? addressLabel : 'Your Address'}}</label>-->
                <label v-if="!!addressLabel && addressLabel.length > 0" class="form-label text-muted mb-3">
                    {{ addressLabel }}
                </label>
                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-cn'">{{ this.getTranslatedText('__address_civic_number__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <input
                            class="form-control"
                            type="text"
                            @input="$emit('update:streetNumber', $event.target.value)"
                            :value="this.streetNumber"
                            :placeholder="this.getTranslatedText('__address_number__', 'fields.placeholders')"
                            :autocomplete="this.autocompleteInput"
                            :name="this.autocompleteInput + '-cn'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('streetNumber')" class="text-danger mb-0"><li><span>{{this.errors('streetNumber')}}</span></li></ul>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-s'">{{ this.getTranslatedText('__address_street__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <input
                            class="form-control"
                            type="text"
                            @input="$emit('update:street', $event.target.value)"
                            :value="this.street"
                            :placeholder="this.getTranslatedText('__address_street__', 'fields.placeholders')"
                            :autocomplete="this.autocompleteInput"
                            :name="this.autocompleteInput + '-s'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('street')" class="text-danger mb-0"><li><span>{{this.errors('street')}}</span></li></ul>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-un'">{{ this.getTranslatedText('__address_unit_number__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <input
                            class="form-control"
                            type="text"
                            @input="$emit('update:unitNumber', $event.target.value)"
                            :value="this.unitNumber"
                            :placeholder="this.getTranslatedText('__address_unit__', 'fields.placeholders')"
                            :autocomplete="this.autocompleteInput"
                            :name="this.autocompleteInput + '-un'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('unitNumber')" class="text-danger mb-0"><li><span>{{this.errors('unitNumber')}}</span></li></ul>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-p'">{{ this.getTranslatedText('__address_postal_code__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <input
                            class="form-control"
                            type="text"
                            @input="$emit('update:postalCode', $event.target.value)"
                            :value="this.postalCode"
                            placeholder="A1A1A1"
                            minlength=6
                            maxlength=7
                            :autocomplete="this.autocompleteInput"
                            :name="this.autocompleteInput + '-p'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('postalCode')" class="text-danger mb-0"><li><span>{{this.errors('postalCode')}}</span></li></ul>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-c'">{{ this.getTranslatedText('__address_city__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <input
                            class="form-control"
                            type="text"
                            @input="$emit('update:city', $event.target.value)"
                            :value="this.city"
                            :placeholder="this.getTranslatedText('__address_city__', 'fields.placeholders')"
                            :autocomplete="this.autocompleteInput"
                            :name="this.autocompleteInput + '-c'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('city')" class="text-danger mb-0"><li><span>{{this.errors('city')}}</span></li></ul>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" :for="this.autocompleteInput + '-pr'">{{ this.getTranslatedText('__address_province__', 'fields.labels') }}</label>
                    <div class="mb-3 input-group">
                        <SelectField
                            :choices="provinces"
                            @input="$emit('update:province', $event)"
                            :value="this.province"
                            :name="this.autocompleteInput + '-pr'"
                        />
                    </div>
                    <div>
                        <ul v-if="this.errors('province')" class="text-danger mb-0"><li><span>{{this.errors('province')}}</span></li></ul>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <button
        v-if="!showExtraFields"
        type="button"
        class="btn btn-small btn-outline-primary"
        @click.prevent.once="showAllFields = true"
    >
        {{ this.getTranslatedText('__address_not_listed__', 'buttons') }}
    </button>
</template>

<script>
import {inject, onMounted, onUnmounted, reactive, ref} from "vue";
import { Loader } from "@googlemaps/js-api-loader";

import SelectField from "@/components/form/inputs/SelectField.vue"

export default {
    name: "GoogleMaps",
    props: {
        title: {
            type: String,
            default: "",
        },
        addressLabel: {
            type: String,
            default: "",
        },
        fullAddress: {
            type: String,
            default: "",
        },
        street: {
            type: String,
            default: "",
        },
        streetNumber: {
            type: String,
            default: "",
        },
        unitNumber: {
            type: String,
            default: "",
        },
        postalCode: {
            type: String,
            default: "",
        },
        city: {
            type: String,
            default: "",
        },
        province: {
            type: String,
            default: "",
        },
        fieldValidator: {
            type: Object,
        },
        isStepReadOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasPrepopAddress: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        SelectField
    },
    setup(props, {emit}) {
        const autocompleteWrapper = ref(null);
        const fullAddressRef = ref();
        let showAllFields = ref(false);
        let addressChanged = ref(false);
        let userInput = "";
        let predictions = ref([])
        let debounceTimeout = null;
        let showLoadingAnimation = ref(false);
        // let fieldErrors = reactive({
        //     street: [],
        //     streetNumber: [],
        //     unitNumber: [],
        //     postalCode: [],
        //     city: [],
        //     province: [],
        // });

        // google APIs
        // let autocompleteAPI; // not used anymore as it does not allow debouncing
        const googleAutocompleteService = ref(null);
        const googlePlaceService = ref(null);

        const { getTranslatedText } = inject('app'); // app is being provided in Application.vue

        const provinces = [
            {"value":"AB", "text":"ALBERTA"},
            {"value":"BC", "text":"BRITISH COLUMBIA"},
            {"value":"MB", "text":"MANITOBA"},
            {"value":"NB", "text":"NEW BRUNSWICK"},
            {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
            {"value":"NS", "text":"NOVA SCOTIA"},
            {"value":"ON", "text":"ONTARIO"},
            {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
            {"value":"QC", "text":"QUEBEC"},
            {"value":"SK", "text":"SASKATCHEWAN"},
            {"value":"NT", "text":"NORTHWEST TERRITORIES"},
            {"value":"NU", "text":"NUNAVUT"},
            {"value":"YT", "text":"YUKON"},
        ];

        // TODO -- get these messages directly from validation-helper.js file
        let customValidationMessages = {};

        let autocompleteInput =  "lcappformfield_" + Math.random();

        onMounted(async () => {

            window.gm_authFailure = () => {
                console.error('gm_authFailure');
                showAllFields.value = true;
            };

            if( !!props.hasPrepopAddress) {
                showAllFields.value = true;
            }
            else {
                const loader = new Loader({
                    apiKey: process.env.MIX_AUTOCOMPLETE_API_KEY,
                    version: "weekly",
                    // ...additionalOptions,
                });

                await loader.load();

                // AutocompleteService ==> used to get the predictions (places)
                // PlacesService ==> used to get the address (street, postal code, province, etc.) from a predicted place
                // const { AutocompleteService, PlacesService } = await google.maps.importLibrary('places'); // this works
                // Google is discontinuing PlacesService. Migrating to Place.
                // For additional details https://developers.google.com/maps/documentation/javascript/places-migration-overview
                // const { AutocompleteService } = await google.maps.importLibrary('places');

                let googlePlacesLibrary = null;
                try {
                    googlePlacesLibrary = await google.maps.importLibrary('places');
                }
                catch (error) {
                    console.error('Error loading Google Places Library:', error);
                    showAllFields.value = true;
                }

                if(googlePlacesLibrary) {
                    googleAutocompleteService.value = new googlePlacesLibrary.AutocompleteService();
                    // Place needs a place_id on creation so we can't instantiate it here as we don't have one yet
                    googlePlaceService.value = googlePlacesLibrary.Place;
                }
                else {
                    console.log('Google Places Library failed to load');
                    showAllFields.value = true;
                }
            }
        });

        onUnmounted(() => {
            if( googleAutocompleteService?.value || googlePlaceService?.value ) {
                // clear listeners by nulling the instances
                if (googleAutocompleteService.value) {
                    google.maps.event.clearInstanceListeners(googleAutocompleteService.value);
                    googleAutocompleteService.value = null;
                }

                if (googlePlaceService.value) {
                    google.maps.event.clearInstanceListeners(googlePlaceService.value);
                    googlePlaceService.value = null;
                }
            }

            if(debounceTimeout) {
                clearTimeout(debounceTimeout);
            }
        });

        return { fullAddressRef, autocompleteWrapper, addressChanged, showAllFields, provinces, autocompleteInput, customValidationMessages, getTranslatedText,
            googleAutocompleteService,
            googlePlaceService,
            userInput,
            predictions,
            debounceTimeout,
            showLoadingAnimation,
            // fieldErrors
        };
    },
    mounted() {
        this.customValidationMessages['postalCode'] = this.getTranslatedText('__postal_code_format__', 'validations');
        let hasStreet = this.street ?? null;
        if( hasStreet ) {
            this.showAllFields = true;
        }
        document.addEventListener('click', this.handleClickOutside)

        // loop through fieldErrors object so we instantiate based on fieldValidator
        // for (const field in this.fieldErrors) {
        //     if (this.fieldValidator && this.fieldValidator.invalidAddressFields && this.fieldValidator.invalidAddressFields.includes(field)) {
        //         this.fieldErrors[field] = this.errors(field);
        //     }
        // }
    },
    beforeUnmount() {
        if(this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        showExtraFields() {
            return this.hasPrepopAddress || this.addressChanged || this.showAllFields;
        },
        getReadOnlyFullAddress() {
            let fullAddress = '';
            if(this.unitNumber) {
                fullAddress += (this.unitNumber ?? '') + '-';
            }
            if(this.streetNumber) {
                fullAddress += (this.streetNumber ?? '') + ' ';
            }
            if(this.street) {
                fullAddress += (this.street ?? '') + '\r\n';
            }
            if(this.city) {
                fullAddress += (this.city ?? '') + ', ';
            }
            if(this.province) {
                fullAddress += (this.province ?? '');
            }
            if(this.postalCode) {
                fullAddress += '\r\n' + (this.postalCode ?? '');
            }
            return fullAddress;
        }
    },
    methods: {
        errors(field) {
            return this.fieldValidator && this.fieldValidator.invalidAddressFields && this.fieldValidator.invalidAddressFields.includes(field) ?
                this.getCustomErrorMessage(field) :
                false;
        },
        getCustomErrorMessage(field) {
            return this.customValidationMessages[field] ?? this.getTranslatedText('__required_field__', 'validations');
        },
        async selectPrediction(prediction) {
            this.userInput = prediction.description;
            this.predictions = [];

            this.addressChanged = true;

            // console.log('selectPrediction');
            // console.log('prediction.place_id');
            // console.log(prediction.place_id);

            // Create the PlacesService instance with the place_id (coming from selected prediction)
            const placeApi = new this.googlePlaceService({
                id: prediction.place_id,
            });

            try {
                await placeApi.fetchFields({
                    fields: ["addressComponents"],
                });
                const addressComponents = placeApi.addressComponents;
                if ( !addressComponents || !addressComponents.length ) {
                    console.error('No address components found');
                    return;
                }

                const mapping = {
                    street_number: "update:streetNumber",
                    route: "update:street",
                    locality: "update:city",
                    postal_code: "update:postalCode",
                    administrative_area_level_1: "update:province",
                };

                const mappingShortVersion = [
                    "postal_code",
                    "administrative_area_level_1",
                ];

                // Emit empty values first
                for ( const type in mapping ) {
                    this.$emit(mapping[type], "");
                }

                await addressComponents.forEach((component) => {
                    component.types.forEach((type) => {
                        if (mapping.hasOwnProperty(type)) {
                            let fieldValue = mappingShortVersion.includes(type) ? component.shortText : component.longText;
                            this.$emit(mapping[type], fieldValue);
                        }
                    });
                });
            }
            catch (error) {
                console.error("Error fetching address components:", error);
                return;
            }

        },
        handleDebouncedInput(event) {
            clearTimeout(this.debounceTimeout);
            this.showLoadingAnimation = true;
            let userInput = event.target.value;
            this.$emit('update:fullAddress', userInput);
            this.debounceTimeout = setTimeout(() => {
                if (!userInput.trim()) {
                    this.predictions = [];
                    return;
                }

                this.googleAutocompleteService.getPlacePredictions(
                    {
                        input: userInput,
                        types: ["address"],
                        componentRestrictions: { country: "ca" },
                    },
                    (results, status) => {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                            this.predictions = results;
                        } else {
                            console.warn('Error fetching predictions:', status);
                            this.showAllFields = true;
                            this.predictions = [];
                        }

                        this.showLoadingAnimation = false;
                    }
                );
            }, 1000);
        },
        handleClickOutside(event) {
            const wrapper = this.$refs.autocompleteWrapper;
            if (wrapper && !wrapper.contains(event.target) && this.predictions.length) {
                this.predictions = [];
                this.addressChanged = true;
                this.showAllFields = true;
            }
        },
    }
};
</script>

<style scoped>
.dropdown-list {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 200px;
    overflow-y: auto;
}

.dropdown-list li.active {
    background-color: #eee;
}

.searching-spinner {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    width: 1rem;
    height: 1rem;
    transform: translateY(-50%);
    border: 2px solid #ccc;
    border-top-color: #333;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to { transform: translateY(-50%) rotate(360deg); }
}
</style>
